import { clone } from 'lodash';
import {
  LEGACY_GET_PORTFOLIO_ITEM,
  SET_PORTFOLIO_ITEM_ERROR,
  SET_NEW_PORTFOLIO_ITEM,
  CLEAR_NEW_PORTFOLIO_ITEM,
  ADD_PORTFOLIO_ITEM,
  DELETE_PORTFOLIO_ITEM,
  SET_LAST_CLICKED_PORTFOLIO_ITEM,
  SET_PORTFOLIO_ITEM,
  SUBMIT_BID,
  SUBMIT_ASK,
} from './actions';

const updatePortfolios = (state, portfolioItem) => {
  const portfolios = clone(state.portfolios) || {};

  // First set
  if (portfolios && !portfolios[portfolioItem.customerId]) {
    portfolios[portfolioItem.customerId] = {};
  }

  if (!portfolioItem.productId) {
    portfolioItem.productId = portfolioItem.skuUuid;
  }

  // Append/Set
  portfolios[portfolioItem.customerId][portfolioItem.chainId] = portfolioItem;

  const { portfolioItemEdit } = state;
  if (portfolioItemEdit) {
    portfolioItemEdit.id = portfolioItem.chainId;
  }

  return {
    ...state,
    portfolios,
  };
};

export function portfolioItem(state = {}, { type = '', payload = {} } = {}) {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'newPortfolioItem' does not exist on type... Remove this comment to see the full error message
  const { newPortfolioItem, error, portfolioItem } = payload;

  switch (type) {
    // @ts-expect-error ts-migrate(2695) FIXME: Left side of comma operator is unused and has no s... Remove this comment to see the full error message
    case (LEGACY_GET_PORTFOLIO_ITEM, SET_PORTFOLIO_ITEM): {
      return { ...state, portfolioItem };
    }

    case SUBMIT_ASK:
    case SUBMIT_BID: {
      return {
        loading: true,
        error: null,
      };
    }

    case SET_NEW_PORTFOLIO_ITEM: {
      return {
        ...state,
        newPortfolioItem: { ...newPortfolioItem },
        error: null,
        loading: false,
      };
    }

    case CLEAR_NEW_PORTFOLIO_ITEM: {
      return {
        ...state,
        newPortfolioItem: null,
        error: null,
      };
    }

    case SET_PORTFOLIO_ITEM_ERROR: {
      return {
        ...state,
        loading: false,
        error,
      };
    }

    case ADD_PORTFOLIO_ITEM: {
      return updatePortfolios(state, portfolioItem);
    }

    case DELETE_PORTFOLIO_ITEM: {
      return { ...state, newPortfolioItem: null };
    }

    case SET_LAST_CLICKED_PORTFOLIO_ITEM: {
      return { ...state, ...payload };
    }

    default:
      return state;
  }
}
